import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: ${props => props.theme.margins.lg};
  iframe {
    height: 600px;
  }
`;

const CodeSandbox = ({ hash, blockNumber }) => (
  <Wrapper data-blocknumber={blockNumber} className="block">
    <iframe
      title="codesandbox"
      src={`https://codesandbox.io/s/${hash}?fontsize=12`}
      sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"
    />
  </Wrapper>
);

export default CodeSandbox;



// WEBPACK FOOTER //
// ./src/book/blocks/CodeSandbox.js